import inputBorderLight from '../../input/border-color/default/light';

const light = (params) => inputBorderLight(params);

export default light;
